export const disabledColor = 'rgba(0, 0, 0, 0.38)';
